import { 
  PlanogramTask, 
  TaskDetail, 
  TaskStatistics, 
  ListResponse,
  MoveOutDetail,
  MoveInDetail,
  RearrangeDetail,
  NewItemDetail,
  OperationOverview,
  TaskProgress,
  TimelineEvent,
  ItemSpec,
  PauseReason
} from '../pages/task-management/task';

// 模拟任务数据
export const mockTasks: PlanogramTask[] = [
  {
    taskCode: 'PLG001',
    shop: 'Store001',
    displayGroup: 'FISH SAUCE',
    division: 'Dry Food',
    shelf: '020-10',
    planogram: 'PLG-2024-001',
    planogramPlan: 'Fish Sauce Promotion Plan 2024',
    planType: 'Major Plans',
    priority: 'High',
    status: 'In Progress',
    planStartDate: '2024-03-01',
    planEndDate: '2024-03-03',
    actualStartTime: '2024-03-01 09:15:00',
    creatorName: 'System',
    gmtCreate: '2024-02-28 16:30:00',
    generateTime: '2024-02-28 16:35:00',
    assignTo: 'John Smith',
    moveOutProgress: { plannedSkuCount: 15, actualSkuCount: 12 },
    moveInProgress: { plannedSkuCount: 8, actualSkuCount: 6 },
    rearrangeProgress: { plannedSkuCount: 10, actualSkuCount: 8 },
    newItemProgress: { plannedSkuCount: 5, actualSkuCount: 5 },
    totalItemsCount: 245,
    totalWeight: 68.5,
    timelineEvents: [
      {
        eventType: 'task_created',
        timestamp: '2024-02-28 16:30:00',
        executor: 'System',
        description: '任务已创建'
      },
      {
        eventType: 'execution_started',
        timestamp: '2024-03-01 09:15:00',
        executor: 'John Smith',
        description: '开始执行任务'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-01 10:30:00',
        executor: 'John Smith',
        operationType: 'moveOut',
        itemCode: 'LJJ001',
        itemName: '李锦记蒸鱼豉油 500ml'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-01 11:45:00',
        executor: 'John Smith',
        operationType: 'moveIn',
        itemCode: 'HT002',
        itemName: '海天生抽 1L'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-01 14:20:00',
        executor: 'John Smith',
        operationType: 'rearrange',
        itemCode: 'LGM003',
        itemName: '老干妈香辣菜 280g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-01 15:30:00',
        executor: 'John Smith',
        operationType: 'newItem',
        itemCode: 'WJS004',
        itemName: '味极鲜生抽 1.28L'
      }
    ]
  },
  {
    taskCode: 'PLG002',
    shop: 'Store001',
    displayGroup: 'OYSTER SAUCE',
    division: 'Dry Food',
    shelf: '021-15',
    planogram: 'PLG-2024-002',
    planogramPlan: 'Oyster Sauce Optimization Plan',
    planType: 'Regular Plans',
    priority: 'Medium',
    status: 'Paused',
    isPaused: true,
    pauseReason: 'Waiting for replenish',
    planStartDate: '2024-03-05',
    planEndDate: '2024-03-07',
    creatorName: 'System',
    gmtCreate: '2024-03-01 10:20:00',
    generateTime: '2024-03-01 10:25:00',
    assignTo: 'Mike Johnson',
    moveOutProgress: { plannedSkuCount: 12, actualSkuCount: 0 },
    moveInProgress: { plannedSkuCount: 6, actualSkuCount: 0 },
    rearrangeProgress: { plannedSkuCount: 8, actualSkuCount: 0 },
    newItemProgress: { plannedSkuCount: 4, actualSkuCount: 0 },
    totalItemsCount: 180,
    totalWeight: 52.3
  },
  {
    taskCode: 'PLG003',
    shop: 'Store001',
    displayGroup: 'VINEGAR',
    division: 'Dry Food',
    shelf: '022-08',
    planogram: 'PLG-2024-003',
    planogramPlan: 'Vinegar New Product Launch Plan',
    planType: 'Urgent Plans',
    priority: 'High',
    status: 'Not Started',
    planStartDate: '2024-03-10',
    planEndDate: '2024-03-10',
    creatorName: 'System',
    gmtCreate: '2024-03-08 14:45:00',
    generateTime: '2024-03-08 14:50:00',
    moveOutProgress: { plannedSkuCount: 8, actualSkuCount: 0 },
    moveInProgress: { plannedSkuCount: 12, actualSkuCount: 0 },
    rearrangeProgress: { plannedSkuCount: 3, actualSkuCount: 0 },
    newItemProgress: { plannedSkuCount: 15, actualSkuCount: 0 },
    totalItemsCount: 320,
    totalWeight: 89.7
  },
  {
    taskCode: 'PLG004',
    shop: 'Store001',
    displayGroup: 'SEASONING SOYBEAN',
    division: 'Dry Food',
    shelf: '023-12',
    planogram: 'PLG-2024-004',
    planogramPlan: 'Seasoning Soybean Seasonal Plan',
    planType: 'Special Plans',
    priority: 'Low',
    status: 'Completed',
    planStartDate: '2024-02-20',
    planEndDate: '2024-02-22',
    actualStartTime: '2024-02-20 09:30:00',
    actualEndTime: '2024-02-22 16:45:00',
    creatorName: 'System',
    gmtCreate: '2024-02-18 11:15:00',
    generateTime: '2024-02-18 11:20:00',
    completeTime: '2024-02-22 16:45:00',
    assignTo: 'David Wilson',
    completeBy: 'David Wilson',
    moveOutProgress: { plannedSkuCount: 10, actualSkuCount: 10 },
    moveInProgress: { plannedSkuCount: 7, actualSkuCount: 7 },
    rearrangeProgress: { plannedSkuCount: 5, actualSkuCount: 5 },
    newItemProgress: { plannedSkuCount: 6, actualSkuCount: 6 },
    totalItemsCount: 156,
    totalWeight: 43.2,
    timelineEvents: [
      {
        eventType: 'task_created',
        timestamp: '2024-02-18 11:15:00',
        executor: 'System',
        description: '任务已创建'
      },
      {
        eventType: 'execution_started',
        timestamp: '2024-02-20 09:30:00',
        executor: 'David Wilson',
        description: '开始执行任务'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-02-20 10:15:00',
        executor: 'David Wilson',
        operationType: 'moveOut',
        itemCode: 'LKK005',
        itemName: '李锦记豆豉鲮鱼 184g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-02-20 11:30:00',
        executor: 'David Wilson',
        operationType: 'moveOut',
        itemCode: 'GWY006',
        itemName: '甘汪豆豉 200g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-02-20 14:20:00',
        executor: 'David Wilson',
        operationType: 'moveIn',
        itemCode: 'YJF007',
        itemName: '鹰金钱豆豉鲮鱼 227g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-02-21 09:45:00',
        executor: 'David Wilson',
        operationType: 'rearrange',
        itemCode: 'ZHJ008',
        itemName: '珠江桥牌豆豉 240g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-02-21 15:10:00',
        executor: 'David Wilson',
        operationType: 'newItem',
        itemCode: 'HT009',
        itemName: '海天豆豉 280g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-02-22 11:20:00',
        executor: 'David Wilson',
        operationType: 'newItem',
        itemCode: 'LGM010',
        itemName: '老干妈豆豉 260g'
      },
      {
        eventType: 'task_completed',
        timestamp: '2024-02-22 16:45:00',
        executor: 'David Wilson',
        description: '任务已完成'
      }
    ]
  },
  {
    taskCode: 'PLG005',
    shop: 'Store001',
    displayGroup: 'CHILLI_TOMATO',
    division: 'Dry Food',
    shelf: '024-06',
    planogram: 'PLG-2024-005',
    planogramPlan: 'Chilli Tomato Optimization Plan',
    planType: 'Regular Plans',
    priority: 'Medium',
    status: 'Completed',
    planStartDate: '2024-03-15',
    planEndDate: '2024-03-16',
    creatorName: 'System',
    gmtCreate: '2024-03-12 09:30:00',
    generateTime: '2024-03-12 09:35:00',
    moveOutProgress: { plannedSkuCount: 6, actualSkuCount: 0 },
    moveInProgress: { plannedSkuCount: 4, actualSkuCount: 0 },
    rearrangeProgress: { plannedSkuCount: 2, actualSkuCount: 0 },
    newItemProgress: { plannedSkuCount: 3, actualSkuCount: 0 },
    totalItemsCount: 95,
    totalWeight: 28.1
  },
  {
    taskCode: 'PLG006',
    shop: 'Store001',
    displayGroup: 'DIPPING',
    division: 'Dry Food',
    shelf: '025-14',
    planogram: 'PLG-2024-006',
    planogramPlan: 'Dipping Sauce Promotion Plan',
    planType: 'Major Plans',
    priority: 'High',
    status: 'Paused',
    isPaused: true,
    pauseReason: 'No resources',
    planStartDate: '2024-03-08',
    planEndDate: '2024-03-10',
    actualStartTime: '2024-03-08 08:45:00',
    creatorName: 'System',
    gmtCreate: '2024-03-06 15:20:00',
    generateTime: '2024-03-06 15:25:00',
    assignTo: 'Sarah Brown',
    moveOutProgress: { plannedSkuCount: 18, actualSkuCount: 14 },
    moveInProgress: { plannedSkuCount: 9, actualSkuCount: 7 },
    rearrangeProgress: { plannedSkuCount: 6, actualSkuCount: 4 },
    newItemProgress: { plannedSkuCount: 12, actualSkuCount: 9 },
    totalItemsCount: 278,
    totalWeight: 76.8
  },
  {
    taskCode: 'PLG007',
    shop: 'Store001',
    displayGroup: 'INSTANT NOODLE',
    division: 'Dry Food',
    shelf: '026-09',
    planogram: 'PLG-2024-007',
    planogramPlan: 'Instant Noodle Category Reset Plan',
    planType: 'Minor Plans',
    priority: 'Low',
    status: 'Not Started',
    planStartDate: '2024-03-20',
    planEndDate: '2024-03-21',
    creatorName: 'System',
    gmtCreate: '2024-03-18 13:40:00',
    generateTime: '2024-03-18 13:45:00',
    moveOutProgress: { plannedSkuCount: 14, actualSkuCount: 0 },
    moveInProgress: { plannedSkuCount: 11, actualSkuCount: 0 },
    rearrangeProgress: { plannedSkuCount: 7, actualSkuCount: 0 },
    newItemProgress: { plannedSkuCount: 8, actualSkuCount: 0 },
    totalItemsCount: 412,
    totalWeight: 125.6
  },
  {
    taskCode: 'PLG008',
    shop: 'Store001',
    displayGroup: 'SUGAR',
    division: 'Dry Food',
    shelf: '027-11',
    planogram: 'PLG-2024-008',
    planogramPlan: 'Sugar Category Plan',
    planType: 'Special Plans',
    priority: 'Medium',
    status: 'Completed',
    planStartDate: '2024-03-25',
    planEndDate: '2024-03-27',
    actualStartTime: '2024-03-25 08:30:00',
    actualEndTime: '2024-03-26 17:20:00',
    creatorName: 'System',
    gmtCreate: '2024-03-22 16:10:00',
    generateTime: '2024-03-22 16:15:00',
    completeTime: '2024-03-26 17:20:00',
    assignTo: 'Emily Davis',
    completeBy: 'Emily Davis',
    moveOutProgress: { plannedSkuCount: 9, actualSkuCount: 9 },
    moveInProgress: { plannedSkuCount: 5, actualSkuCount: 5 },
    rearrangeProgress: { plannedSkuCount: 4, actualSkuCount: 4 },
    newItemProgress: { plannedSkuCount: 7, actualSkuCount: 7 },
    totalItemsCount: 203,
    totalWeight: 61.4,
    timelineEvents: [
      {
        eventType: 'task_created',
        timestamp: '2024-03-22 16:10:00',
        executor: 'System',
        description: '任务已创建'
      },
      {
        eventType: 'execution_started',
        timestamp: '2024-03-25 08:30:00',
        executor: 'Emily Davis',
        description: '开始执行任务'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-25 09:45:00',
        executor: 'Emily Davis',
        operationType: 'moveOut',
        itemCode: 'TT011',
        itemName: '太太乐白砂糖 454g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-25 11:20:00',
        executor: 'Emily Davis',
        operationType: 'moveIn',
        itemCode: 'GF012',
        itemName: '古方红糖 500g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-25 14:30:00',
        executor: 'Emily Davis',
        operationType: 'rearrange',
        itemCode: 'YT013',
        itemName: '英糖冰糖 350g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-26 10:15:00',
        executor: 'Emily Davis',
        operationType: 'newItem',
        itemCode: 'FT014',
        itemName: '福田椰糖 400g'
      },
      {
        eventType: 'operation_completed',
        timestamp: '2024-03-26 15:45:00',
        executor: 'Emily Davis',
        operationType: 'newItem',
        itemCode: 'HX015',
        itemName: '华兴黄糖 300g'
      },
      {
        eventType: 'task_completed',
        timestamp: '2024-03-26 17:20:00',
        executor: 'Emily Davis',
        description: '任务已完成'
      }
    ]
  },
  {
    taskCode: 'PLG009',
    shop: 'Store001',
    displayGroup: 'COOKING OIL',
    division: 'Dry Food',
    shelf: '028-05',
    planogram: 'PLG-2024-009',
    planogramPlan: 'Cooking Oil Premium Brand Plan',
    planType: 'Major Plans',
    priority: 'High',
    status: 'Completed',
    planStartDate: '2024-03-12',
    planEndDate: '2024-03-14',
    actualStartTime: '2024-03-12 09:00:00',
    actualEndTime: '2024-03-13 16:30:00',
    creatorName: 'System',
    gmtCreate: '2024-03-10 14:20:00',
    generateTime: '2024-03-10 14:25:00',
    completeTime: '2024-03-13 16:30:00',
    assignTo: 'Alex Chen',
    completeBy: 'Alex Chen',
    moveOutProgress: { plannedSkuCount: 12, actualSkuCount: 12 },
    moveInProgress: { plannedSkuCount: 8, actualSkuCount: 8 },
    rearrangeProgress: { plannedSkuCount: 6, actualSkuCount: 6 },
    newItemProgress: { plannedSkuCount: 10, actualSkuCount: 10 },
    totalItemsCount: 285,
    totalWeight: 78.9
  },

];

// 模拟任务明细数据
export const mockTaskDetails: Record<string, TaskDetail[]> = {
  'PLG001': [
    {
      item: 'Coca Cola 330ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 8,
      targetDepth: 5,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Pepsi 330ml',
      shelfLevel: 2,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 2,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 2,
      remark: '扩展现有商品',
    },
    {
      item: 'Sprite 330ml',
      shelfLevel: 3,
      currentFacing: 6,
      currentDepth: 4,
      currentLevel: 1,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 3,
      actionType: 'Shrink',
      status: 'Pending',
      displayOrder: 3,
      remark: '收缩现有商品',
    },
    {
      item: 'Fanta 330ml',
      shelfLevel: 1,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Pending',
      displayOrder: 4,
      remark: '商品下架',
    },
    {
      item: 'Dr Pepper 330ml',
      shelfLevel: 2,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 5,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 5,
      remark: '新商品上架',
    },
    {
      item: '7UP 330ml',
      shelfLevel: 3,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 3,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 6,
      remark: '扩展现有商品',
    },
    {
      item: 'Mountain Dew 330ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 7,
      remark: '新商品上架',
    },
    {
      item: 'Orange Crush 330ml',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 2,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'Shrink',
      status: 'Completed',
      displayOrder: 8,
      remark: '收缩现有商品',
    },
  ],
  'PLG002': [
    {
      item: 'Shampoo 500ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Body Wash 500ml',
      shelfLevel: 2,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Pending',
      displayOrder: 2,
      remark: '商品下架',
    },
    {
      item: 'Conditioner 500ml',
      shelfLevel: 1,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 1,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 3,
      remark: '扩展现有商品',
    },
    {
      item: 'Hair Mask 300ml',
      shelfLevel: 3,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 3,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Shower Gel 750ml',
      shelfLevel: 2,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 2,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Hair Oil 200ml',
      shelfLevel: 1,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 2,
      targetDepth: 2,
      targetLevel: 1,
      actionType: 'Shrink',
      status: 'Pending',
      displayOrder: 6,
      remark: '收缩现有商品',
    },
    {
      item: 'Face Wash 150ml',
      shelfLevel: 3,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Exception',
      displayOrder: 7,
      remark: '商品下架',
    },
    {
      item: 'Leave-in Treatment 250ml',
      shelfLevel: 2,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 8,
      remark: '新商品上架',
    },
  ],
  'PLG003': [
    {
      item: 'Apple Cider Vinegar 500ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 5,
      targetDepth: 4,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Balsamic Vinegar 250ml',
      shelfLevel: 2,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 2,
      remark: '扩展现有商品',
    },
    {
      item: 'White Vinegar 500ml',
      shelfLevel: 1,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 1,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 1,
      actionType: 'Shrink',
      status: 'Pending',
      displayOrder: 3,
      remark: '收缩现有商品',
    },
    {
      item: 'Rice Vinegar 300ml',
      shelfLevel: 3,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 3,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Red Wine Vinegar 250ml',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 5,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Malt Vinegar 500ml',
      shelfLevel: 1,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Pending',
      displayOrder: 6,
      remark: '商品下架',
    },
    {
      item: 'Coconut Vinegar 400ml',
      shelfLevel: 3,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 3,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 7,
      remark: '新商品上架',
    },
  ],
  'PLG004': [
    {
      item: 'Light Soy Sauce 500ml',
      shelfLevel: 1,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Completed',
      displayOrder: 1,
      remark: '商品下架',
    },
    {
      item: 'Dark Soy Sauce 500ml',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Completed',
      displayOrder: 2,
      remark: '商品下架',
    },
    {
      item: 'Premium Soy Sauce 500ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 3,
      remark: '新商品上架',
    },
    {
      item: 'Organic Soy Sauce 750ml',
      shelfLevel: 2,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Mushroom Soy Sauce 400ml',
      shelfLevel: 3,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 3,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Sweet Soy Sauce 300ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 5,
      targetDepth: 3,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 6,
      remark: '新商品上架',
    },
  ],
  'PLG005': [
    {
      item: 'Chilli Sauce 300ml',
      shelfLevel: 1,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Exception',
      displayOrder: 1,
      remark: '商品下架',
    },
    {
      item: 'Tomato Sauce 300ml',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Exception',
      displayOrder: 2,
      remark: '商品下架',
    },
    {
      item: 'Sriracha Sauce 250ml',
      shelfLevel: 3,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 3,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 3,
      remark: '新商品上架',
    },
    {
      item: 'BBQ Sauce 400ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Hot Sauce 200ml',
      shelfLevel: 2,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Garlic Sauce 350ml',
      shelfLevel: 3,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 2,
      targetDepth: 2,
      targetLevel: 3,
      actionType: 'Shrink',
      status: 'Completed',
      displayOrder: 6,
      remark: '收缩现有商品',
    },
  ],
  'PLG006': [
    {
      item: 'Sweet Chili Sauce 250ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Hoisin Sauce 250ml',
      shelfLevel: 2,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 2,
      remark: '扩展现有商品',
    },
    {
      item: 'Old Dipping Sauce 200ml',
      shelfLevel: 3,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Completed',
      displayOrder: 3,
      remark: '商品下架',
    },
    {
      item: 'Teriyaki Sauce 300ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 5,
      targetDepth: 3,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Oyster Sauce 500ml',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Fish Sauce 200ml',
      shelfLevel: 3,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Pending',
      displayOrder: 6,
      remark: '商品下架',
    },
    {
      item: 'Plum Sauce 350ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 7,
      remark: '新商品上架',
    },
  ],
  'PLG007': [
    {
      item: 'Instant Noodle Beef 120g',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 8,
      targetDepth: 5,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Instant Noodle Chicken 120g',
      shelfLevel: 2,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 2,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 2,
      remark: '扩展现有商品',
    },
    {
      item: 'Old Noodle Brand 100g',
      shelfLevel: 3,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Pending',
      displayOrder: 3,
      remark: '商品下架',
    },
    {
      item: 'Instant Noodle Seafood 130g',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Instant Noodle Pork 125g',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 5,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Cup Noodle Spicy 75g',
      shelfLevel: 3,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 3,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 6,
      remark: '新商品上架',
    },
  ],
  'PLG008': [
    {
      item: 'White Sugar 1kg',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 5,
      targetDepth: 4,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Brown Sugar 500g',
      shelfLevel: 2,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 2,
      remark: '扩展现有商品',
    },
    {
      item: 'Raw Sugar 1kg',
      shelfLevel: 1,
      currentFacing: 3,
      currentDepth: 3,
      currentLevel: 1,
      targetFacing: 2,
      targetDepth: 2,
      targetLevel: 1,
      actionType: 'Shrink',
      status: 'Pending',
      displayOrder: 3,
      remark: '收缩现有商品',
    },
    {
      item: 'Caster Sugar 750g',
      shelfLevel: 3,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 3,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 4,
      remark: '新商品上架',
    },
    {
      item: 'Icing Sugar 500g',
      shelfLevel: 2,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 5,
      remark: '扩展现有商品',
    },
    {
      item: 'Palm Sugar 400g',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 6,
      remark: '新商品上架',
    },
    {
      item: 'Rock Sugar 600g',
      shelfLevel: 3,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Exception',
      displayOrder: 7,
      remark: '商品下架',
    },
  ],
  'PLG009': [
    {
      item: 'Premium Olive Oil 500ml',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 6,
      targetDepth: 4,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 1,
      remark: '新商品上架',
    },
    {
      item: 'Sunflower Oil 1L',
      shelfLevel: 2,
      currentFacing: 4,
      currentDepth: 3,
      currentLevel: 2,
      targetFacing: 5,
      targetDepth: 4,
      targetLevel: 2,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 2,
      remark: '扩展现有商品',
    },
    {
      item: 'Vegetable Oil 500ml',
      shelfLevel: 3,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 3,
      actionType: 'Expand',
      status: 'Completed',
      displayOrder: 3,
      remark: '扩展现有商品',
    },
    {
      item: 'Coconut Oil 250ml',
      shelfLevel: 1,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 1,
      targetFacing: 0,
      targetDepth: 0,
      targetLevel: 0,
      actionType: 'De-Listing',
      status: 'Completed',
      displayOrder: 4,
      remark: '商品下架',
    },
    {
      item: 'Sesame Oil 300ml',
      shelfLevel: 2,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'New Put-Away',
      status: 'Pending',
      displayOrder: 5,
      remark: '新商品上架',
    },
    {
      item: 'Canola Oil 750ml',
      shelfLevel: 3,
      currentFacing: 2,
      currentDepth: 2,
      currentLevel: 3,
      targetFacing: 3,
      targetDepth: 2,
      targetLevel: 3,
      actionType: 'Expand',
      status: 'Pending',
      displayOrder: 6,
      remark: '扩展现有商品',
    },
    {
      item: 'Peanut Oil 1L',
      shelfLevel: 1,
      currentFacing: 0,
      currentDepth: 0,
      currentLevel: 0,
      targetFacing: 4,
      targetDepth: 3,
      targetLevel: 1,
      actionType: 'New Put-Away',
      status: 'Completed',
      displayOrder: 7,
      remark: '新商品上架',
    },
    {
      item: 'Corn Oil 500ml',
      shelfLevel: 2,
      currentFacing: 3,
      currentDepth: 2,
      currentLevel: 2,
      targetFacing: 2,
      targetDepth: 2,
      targetLevel: 2,
      actionType: 'Shrink',
      status: 'Completed',
      displayOrder: 8,
      remark: '收缩现有商品',
    },
  ],
};

// 模拟统计数据
export const mockStatistics: TaskStatistics = {
  totalTasks: 9,
  notStartedTasks: 3,
  inProgressTasks: 2,
  pausedTasks: 2,
  completedTasks: 2,
};

// 模拟选项数据
export const mockOptions = {
  shops: [
    { value: 'Store001', label: 'Store001' },
  ],
  divisions: [
    { value: 'Dry Food', label: 'Dry Food' },
    { value: 'Fresh Food', label: 'Fresh Food' },
    { value: 'None Food', label: 'None Food' },
  ],
  displayGroups: {
    'Store001': [
      { value: 'FISH SAUCE', label: 'FISH SAUCE' },
      { value: 'OYSTER SAUCE', label: 'OYSTER SAUCE' },
      { value: 'VINEGAR', label: 'VINEGAR' },
      { value: 'SEASONING SOYBEAN', label: 'SEASONING SOYBEAN' },
      { value: 'CHILLI_TOMATO', label: 'CHILLI_TOMATO' },
      { value: 'DIPPING', label: 'DIPPING' },
      { value: 'INSTANT NOODLE', label: 'INSTANT NOODLE' },
      { value: 'SUGAR', label: 'SUGAR' },
      { value: 'COOKING OIL', label: 'COOKING OIL' },
    ],
  },
  shelves: {
    'FISH SAUCE': [
      { value: '020-10', label: '020-10' },
      { value: '020-11', label: '020-11' },
    ],
    'OYSTER SAUCE': [
      { value: '021-15', label: '021-15' },
      { value: '021-16', label: '021-16' },
    ],
    'VINEGAR': [
      { value: '022-08', label: '022-08' },
      { value: '022-09', label: '022-09' },
      { value: '022-10', label: '022-10' },
    ],
    'SEASONING SOYBEAN': [
      { value: '023-12', label: '023-12' },
      { value: '023-13', label: '023-13' },
    ],
    'CHILLI_TOMATO': [
      { value: '024-06', label: '024-06' },
      { value: '024-07', label: '024-07' },
    ],
    'DIPPING': [
      { value: '025-14', label: '025-14' },
      { value: '025-15', label: '025-15' },
    ],
    'INSTANT NOODLE': [
      { value: '026-09', label: '026-09' },
      { value: '026-10', label: '026-10' },
    ],
    'SUGAR': [
      { value: '027-11', label: '027-11' },
      { value: '027-12', label: '027-12' },
    ],
    'COOKING OIL': [
      { value: '028-05', label: '028-05' },
      { value: '028-06', label: '028-06' },
    ],
  },
  users: [
    { value: 'John Smith', label: 'John Smith' },
    { value: 'Mike Johnson', label: 'Mike Johnson' },
    { value: 'David Wilson', label: 'David Wilson' },
    { value: 'Sarah Brown', label: 'Sarah Brown' },
    { value: 'Emily Davis', label: 'Emily Davis' },
    { value: 'Alex Chen', label: 'Alex Chen' },
  ],
  planogramPlans: [
    { value: 'Fish Sauce Promotion Plan 2024', label: 'Fish Sauce Promotion Plan 2024' },
    { value: 'Oyster Sauce Optimization Plan', label: 'Oyster Sauce Optimization Plan' },
    { value: 'Vinegar New Product Launch Plan', label: 'Vinegar New Product Launch Plan' },
    { value: 'Seasoning Soybean Seasonal Plan', label: 'Seasoning Soybean Seasonal Plan' },
    { value: 'Chilli Tomato Optimization Plan', label: 'Chilli Tomato Optimization Plan' },
    { value: 'Dipping Sauce Promotion Plan', label: 'Dipping Sauce Promotion Plan' },
    { value: 'Instant Noodle Category Reset Plan', label: 'Instant Noodle Category Reset Plan' },
    { value: 'Sugar Category Plan', label: 'Sugar Category Plan' },
    { value: 'Cooking Oil Premium Brand Plan', label: 'Cooking Oil Premium Brand Plan' },
  ],
};

// 模拟API响应
export const createMockResponse = <T>(data: T | null, success = true, errorMessage: string | null = null) => ({
  traceId: Math.random().toString(36).substr(2, 9),
  success,
  errorMessage,
  flag: success ? 'success' as const : 'fail' as const,
  data,
});

// 模拟列表响应
export const createMockListResponse = <T>(
  tableData: T[], 
  currentPage = 1, 
  pageSize = 20,
  totalCount?: number
): ListResponse<T> => ({
  tableData,
  paging: {
    currentPage,
    totalCount: totalCount || tableData.length,
    pageSize,
  },
});

// 模拟延迟
export const mockDelay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));